import { InternalPaymentsWidgetProps } from '../types/InternalPaymentsWidgetProps';

export interface IWidgetLazyComponentProps extends InternalPaymentsWidgetProps {
  startLoadTime: number;
}

export const WIDGET_ID = 'CashierPaymentsWidget';
export const LAZY_WIDGET_ID = 'CashierWidgetLazy';
